<script>
/**
 * Imports
 */
import SignupFormInput from "./../form/SignupFormInput.vue";
import SignupPackagesOption from "./../packages/SignupPackagesOption.vue";

/**
 * Component: Packages: Group
 *
 * @author PH
 */
export default {
  props: ["id", "title", "fields"],
  computed: {
    visibleFields() {
      return this.fields.filter(f => f.visible !== false);
    }
  },

  components: { SignupFormInput, SignupPackagesOption }
};
</script>

<template>
  <div class="signup-packages-group" v-if="visibleFields.length">
    <div class="signup-packages-group__title" v-if="title">
      <h4>{{title}}</h4>
    </div>

    <div class="signup-packages-group__options">
      <signup-packages-option
        v-for="field in visibleFields"
        v-bind:key="field.id"
        v-bind:id="field.id"
        v-bind:name="field.name"
        v-bind:type="field.type"
        v-bind:title="field.placeholder"
        v-bind:description="field.description"
        v-bind:settings="field.settings"
      ></signup-packages-option>
    </div>
  </div>
</template>

